const $ = require('jquery');
const vex = require('vex');
const vexDialog = require('vexDialog');
const get = require('lodash').get;

module.exports = {
  init() {
    if (!get(globals, 'popups.autoHighlight', false)) {
      return 0;
    }
    let confirmText = `<p>${get(translations, 'txt: Sveiki!', '')}</p>`;
    confirmText += `<p>${get(translations, 'txt: Mēs pēc nejaušības principa esam izvēlējušies Tavu profilu izcelt! Šī iespēja sniedz Tev daudz lielāku uzmanību no citiem lietotājiem, padarot iepazīšanos jautrāku un dinamiskāku. ', '')}</p>`;
    confirmText += `<p>${get(translations, 'txt: Vai vēlies, lai Tavs profils tiek izcelts uz vienu dienu bez maksas?', '')}</p>`;
    vexDialog.confirm({
      message: confirmText,
      buttons: [
        {
          type: 'button',
          text: get(translations, 'txt: Jā, lūdzu', ''),
          className: 'vex-dialog-button-primary',
          click($vexContent, event) {
            $vexContent.data().vex.value = 'yes';
            return vex.close($vexContent.data().vex.id);
          },
        },
        {
          type: 'button',
          text: get(translations, 'txt: Nē, paldies', ''),
          className: 'vex-dialog-button-primary',
          click($vexContent, event) {
            $vexContent.data().vex.value = 'no';
            return vex.close($vexContent.data().vex.id);
          },
        },
      ],
      callback(response) {
        if (response === 'yes' || response === 'no') {
          $.ajax({
            type: 'GET',
            url: `${_.get(globals, 'apiWebroot', '/')}member/confirm_highlight/${response}`,
            success() {
              window.location = get(globals, 'webroot', '');
            },
          });
        }
      },
    });
    return 1;
  },
};
